import { ParsingError } from '../../errors/ParsingError';
import { UnauthorizedError } from '../../errors/UnauthorizedError';
import { Fetcher } from '../../Fetcher';

import type { IRtpResponse, RtpType } from './types';

export interface FetchRtpParams {
  JSESSIONID: string;
  tableVariant: string;
  url: string;
}

export const fetchRtp = ({ JSESSIONID, tableVariant, url }: FetchRtpParams): Promise<RtpType> => {
  return Fetcher.fetch<IRtpResponse>(url, {
    params: {
      tableVariant,
      JSESSIONID,
    },
  }).then((response) => {
    if (response.description.includes('Invalid user session')) {
      throw new UnauthorizedError('RTP fetcher:  Invalid user session');
    } else if (!response.data) {
      throw new ParsingError('RTP fetcher: Invalid response, no data received');
    }

    return JSON.parse(response.data);
  });
};
